import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { Ripple } from "primereact/ripple";
import { confirmDialog } from "primereact/confirmdialog";
import { Image } from "primereact/image";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";

import NoDataCreated from "../../../../../Components/NoDataCreated";
import ErrorPage from "../../../../../Components/ErrorPage";
import TenderDocumentModal from "./TenderDocumentModal";
import PageLoader from "../../../../../Components/PageLoader";
import { goToTop } from "../../../../../Components/goToTop";
import { baseURL } from "../../../../../Api/ApiConstant";

import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../Controllers/hooks";
import {
  mapShareContactDetailsList,
  ShareContact,
  ShareContactDetails,
  ShareContactDetailsPayload,
} from "../../../../../Controllers/Types/Project/ShareContactInterface";
import {
  addTenderDocumentApi,
  deleteSow,
  shareContactForSowApi,
  shareContactForTenderListAndDocumentApi,
} from "../../../../../Api/tenderApi";
import {
  ProjectTenderDetailInterface,
  TenderShareContact,
} from "../../../../../Controllers/Types/Tender/projectTenderDetailsInterface";
import { checkFileOthers, checkText } from "../../../../../Utils/Validator";
import { ShowToast } from "../../../../../Components/ShowToast";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../Controllers/Store";
import { hasPermission } from "../../../../../Controllers/Selectors/permissionsSelector";
import { SharedFolderBy } from "../../../../../Controllers/Types/Project/SharedFolderBy";
import { ProjectBasicContact } from "../../../../../Controllers/Types/Project/ProjectInterface";
import { setSubFolderAllContact } from "../../../../../Controllers/Slices/projectDetailsSlice";

const Tender: React.FC = () => {
  const error = "";

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const itemData = location.state.data as any;
  const folder_id = itemData.folder_id as number;
  const jobNo = itemData.job_number as string;
  const address = itemData.address as string;
  const serviceName = itemData.service_name as string;
  const featureName = itemData.feature_name as string;
  const folderName = itemData.folder as string;
  const sharedBy = itemData.sharedBy as SharedFolderBy | null;

  const sharedContacttDetails: ShareContact[] = itemData.serviceAssignedContact as ShareContact[];
  const projectAllContact: ProjectBasicContact[] = itemData.projectAllContact as ProjectBasicContact[];

  const [userType, setUserType] = useState<
    "Employee" | "Professional" | "Client" | null
  >(null);

  const toast = useRef<Toast>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("");

  const [showDocumentModal, setShowDocumentModal] = useState<boolean>(false);

  /* Tender document form fields */
  const [documentName, setDocumentName] = useState<string>("");
  const [file, setFile] = useState<File | null>(null);
  const [fileName, setFileName] = useState<string>("");

  /* Error */
  const [documentNameError, setDocumentNameError] = useState<string>("");
  const [fileError, setFileError] = useState<string>("");

  const [showShareContactModal, setShowShareContactModal] =
    useState<boolean>(false);
  const [projectTenderDetailInterface, setProjectTenderDetailInterface] =
    useState<ProjectTenderDetailInterface | null>(null);

  const [showSharedListModal, setShowSharedListModal] =
    useState<boolean>(false);

  const [selectedTenderSharedContacts, setSelectedTenderSharedContacts] =
    useState<TenderShareContact[]>([]);

  const [filterSharedList, setFilterContacts] = useState<ShareContactDetails[]>(
    []
  );
  const [allfilterSharedList, setAllFilterContacts] = useState<
    ShareContactDetails[]
  >([]);

  const {
    loadingProjectTenderDetail,
    projectTenderDetail,
    sharedContacttDetailList,
    filteredContacttDetailList,
  } = useAppSelector((state) => state.tender);

  const [showTenderOverviewModal, setShowTenderOverviewModal] =
    useState<boolean>(false);
  const [isCoverPageAdded, setIsCoverPageAdded] = useState<boolean>(true);
  const [isTenderContentAdded, setIsTenderContentAdded] =
    useState<boolean>(false);
  const [isPreliminaryAdded, setIsPreliminaryAdded] = useState<boolean>(false);

  const useCanEdit = (screen: string, permission: string) => {
    return useSelector((state: RootState) =>
      hasPermission(state, screen, permission)
    );
  };

  const isPermission_schedule_of_work = useCanEdit(
    "Tender",
    "schedule_of_work"
  );
  const isPermission_tender_list = useCanEdit("Tender", "tender_list");
  const isPermission_tender_document = useCanEdit("Tender", "tender_document");
  const isPermission_add_tender_document = useCanEdit(
    "Tender",
    "add_tender_document"
  );
  const isPermission_update_tender_list = useCanEdit(
    "Tender",
    "update_tender_list"
  );
  const isPermission_add_schedule_of_work = useCanEdit(
    "Tender",
    "add_schedule_of_work"
  );
  const isPermission_tender_document_share = useCanEdit(
    "Tender",
    "tender_document_share"
  );

  const isPermission_dwonload_schedule_of_work = useCanEdit(
    "Tender",
    "dwonload_schedule_of_work"
  );
  const isPermission_download_tender_list = useCanEdit(
    "Tender",
    "download_tender_list"
  );
  const isPermission_delete_schedule_of_work = useCanEdit(
    "Tender",
    "delete_schedule_of_work"
  );

  useEffect(() => {
    setAllFilterContacts(sharedContacttDetailList);
  }, []);

  useEffect(() => {
    handleFilter(userType!);
  }, [userType]);

  const handleFilter = async (userType: string) => {
    const { setFilterContact } = await import(
      "../../../../../Controllers/Slices/tenderSlice"
    );
    dispatch(setFilterContact(userType));
  };

  useEffect(() => {
    const loadThunk = async () => {
      const { getProjectTenderDetailList } = await import(
        "../../../../../Controllers/Thunks/tenderThunks"
      );
      const { setSharedContactDetails } = await import(
        "../../../../../Controllers/Slices/tenderSlice"
      );

      dispatch(getProjectTenderDetailList(folder_id));



      dispatch(setSharedContactDetails({
        sharedContact: sharedContacttDetails,
        projctAllContact: projectAllContact,
      }));
    };
    loadThunk();

  }, [dispatch, folder_id]);



  /* ******************************** For tender document ******************************** */
  const handleAddDocument = (tender: ProjectTenderDetailInterface) => {
    setProjectTenderDetailInterface(tender);
    setShowDocumentModal(true);

    setDocumentName("");
    setFile(null);
    setFileName("");
    setDocumentNameError("");
    setFileError("");
  };

  function checkCredentialsUploadFile(isRequiredFile: boolean): boolean {
    const isServiceNameValid = checkText(
      documentName,
      true,
      setDocumentNameError
    );
    const isUploadedFileValid = checkFileOthers(
      file!,
      isRequiredFile,
      setFileError
    );

    return isServiceNameValid && isUploadedFileValid;
  }

  const handleCreateTenderDocument = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentialsUploadFile(true)) {
      setLoading(true);

      const res = await addTenderDocumentApi(
        projectTenderDetailInterface?.project_tender_part_id!,
        documentName,
        file!
      );

      setLoading(false);

      if (res.status) {
        const { getProjectTenderDetailList } = await import(
          "../../../../../Controllers/Thunks/tenderThunks"
        );

        dispatch(getProjectTenderDetailList(folder_id));

        setShowAlert(true);
        setSuccessMessage("Document added successfully.");

        setTimeout(() => {
          setShowAlert(false);
        }, 2000);

        handleCloseDocumentModal();
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error creating document",
            life: 3000,
          });
        }
      }
    }
  };

  const handleCloseDocumentModal = () => {
    setShowDocumentModal(false);
  };

  const handleFileUpload = (file: File) => {
    setFileName(file.name);
    setFile(file);
  };

  const handleClearFile = () => {
    setFileName("");
    setFile(null);
  };

  /* ************************************************************************************ */

  /* ******************************** For shared list  ********************************** */
  const handleShowSharedListModal = (contacts: TenderShareContact[]) => {
    setSelectedTenderSharedContacts(contacts);
    setShowSharedListModal(true);
  };

  const handleCloseSharedListModal = () => {
    setShowSharedListModal(false);
  };

  /* Modal header */
  const shareListModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Share list</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseSharedListModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );
  /* ************************************************************************************ */

  /* ********************************** For table view ********************************** */
  const sharedContactBody = (rowData: ProjectTenderDetailInterface) => {
    const contacts = rowData.share_contact;
    return (
      <React.Fragment>
        {contacts?.length > 0 ? (
          <div
            className="project_card_contact_area pt-2 pb-2 ps-0 pe-0 mt-0 p-ripple"
            onClick={() => handleShowSharedListModal(contacts)}
          >
            {contacts.slice(0, 3).map((contact) => (
              <div key={contact.id} className="project_card_contact">
                {contact.first_name[0]}
                {contact.last_name[0]}
              </div>
            ))}

            {contacts.length > 3 && (
              <h6 className="project_card_contact_has_more">
                +{contacts.length - 3}
              </h6>
            )}
            <Ripple />
          </div>
        ) : (
          <div
            className="text-secondary"
            style={{ height: "46px", display: "flex", alignItems: "center" }}
          >
            ---
          </div>
        )}
      </React.Fragment>
    );
  };

  const tableActionBody = (rowData: ProjectTenderDetailInterface) => {
    return (
      <div className={`table_action_btn_area ${sharedBy !== null ? 'justify-content-end' : ''}`}>
        {/* ======================================================== VIEW BUTTON =============================================================*/}

        {rowData.title === "Schedule of work" ? (
          <button
            className="table_action_btn p-ripple"
            onClick={() => {
              handleShowTenderOverview(rowData);
            }}
            disabled={
              !isDisableViewButton(
                rowData.have_cover_page_data,
                rowData.have_content_data,
                rowData.have_priliminiery_data
              )
            }
          >
            View
            <Ripple />

          </button>
        ) : rowData.title === "Tender List" ? (
          <button
            className="table_action_btn p-ripple"
            onClick={() => {
              navigate(
                `/project/detail/default-service/pre-commencement/tender/tender-list`,
                { state: rowData }
              );
            }}
          // disabled={rowData.tender_list.length > 0 ? false : true}
          // disabled
          >
            View
            <Ripple />
          </button>
        ) : (
          <button
            className="table_action_btn p-ripple"
            onClick={() => {
              navigate("/project/detail/default-service/pre-commencement/tender/tender-document", { state: { tenderDocument: rowData, projectData: itemData } });
            }}
          >
            View
            <Ripple />
          </button>
        )
        }

        {/* ======================================================== ADD BUTTON =============================================================*/}

        {
          rowData.title === "Schedule of work" ? (
            <button
              className="table_action_btn p-ripple"
              onClick={() => {
                navigate(
                  `/project/detail/default-service/pre-commencement/tender/sow`,
                  { state: rowData }
                );
              }}
              disabled={
                !isDisableAddButtonWithPermission(
                  rowData.have_cover_page_data,
                  rowData.have_content_data,
                  rowData.have_priliminiery_data,
                  isPermission_add_schedule_of_work
                )
              }
            >
              Add
              <Ripple />
            </button>
          ) : rowData.title === "Tender List" ? (
            <button
              className={`table_action_btn p-ripple ${sharedBy !== null ? 'd-none' : ''}`}
              onClick={() => {
                navigate(`#`);
              }}
              disabled={rowData.title === "Tender List"}
            >
              Add
              <Ripple />
            </button>
          ) : (
            <button
              className="table_action_btn p-ripple"
              onClick={() => {
                handleAddDocument(rowData);
              }}
              disabled={!isPermission_add_tender_document}
            >
              Add
              <Ripple />
            </button>
          )
        }

        {
          rowData.title === "Schedule of work" ? (
            <button
              className="table_action_btn p-ripple"
              onClick={() => handleShare(rowData)}
              disabled={
                !isDisableViewButton(
                  rowData.have_cover_page_data,
                  rowData.have_content_data,
                  rowData.have_priliminiery_data
                )
              }
            >
              Share
              <Ripple />
            </button>
          ) : rowData.title === "Tender List" || rowData.title === "Tender Document" ? (
            <button
              className={`table_action_btn p-ripple ${sharedBy !== null ? 'd-none' : ''}`}
              disabled={true}>
              Share
              {rowData.title !== "Tender List" && <Ripple />}
            </button>
          ) : (
            <button
              className="table_action_btn p-ripple"
              onClick={() => handleShare(rowData)}
              disabled={!isPermission_tender_document_share}
            >
              Share
              <Ripple />
            </button>
          )
        }

        {
          rowData.title === "Schedule of work" ? (
            <button
              className="table_action_btn p-ripple"
              onClick={() => {
                if (rowData.share_contact.length === 0) {
                  handleDeleteSOW(rowData);
                } else {
                  ShowToast(
                    toast,
                    "error",
                    "Deletion denied",
                    "This schedule of work shared with others"
                  );
                }
              }}
              disabled={
                !isDisableDeleteButtonWithPermission(
                  rowData.have_cover_page_data,
                  rowData.have_content_data,
                  rowData.have_priliminiery_data,
                  isPermission_delete_schedule_of_work
                )
              }
            >
              Delete
              <Ripple />
            </button>
          ) : rowData.title === "Tender List" ? (
            <button
              className={`table_action_btn p-ripple ${sharedBy !== null ? 'd-none' : ''}`}
              onClick={() => { }}
              disabled={true}
            >
              Delete
              <Ripple />
            </button>
          ) : (
            <button
              className="table_action_btn p-ripple"
              onClick={() => { }}
              disabled={true}
            >
              Delete
              <Ripple />
            </button>
          )
        }
      </div >
    );
  };

  const isDisableViewButton = (
    have_cover_page_data: boolean,
    have_content_data: boolean,
    have_priliminiery_data: boolean
  ) => {

    const isData =
      have_cover_page_data || have_content_data || have_priliminiery_data;
    if (isData === true) {
      return true;
    } else {
      return false;
    }
  };

  const isDisableAddButtonWithPermission = (
    have_cover_page_data: boolean,
    have_content_data: boolean,
    have_priliminiery_data: boolean,
    permission: boolean
  ) => {

    if (
      have_cover_page_data === false &&
      have_content_data === false &&
      have_priliminiery_data === false &&
      permission === true
    ) {
      return true;
    } else {
      return false;
    }
  };

  const isDisableDeleteButtonWithPermission = (
    have_cover_page_data: boolean,
    have_content_data: boolean,
    have_priliminiery_data: boolean,
    permission: boolean
  ) => {
    const isData =
      have_cover_page_data || have_content_data || have_priliminiery_data;
    if (isData === true && permission === true) {
      return true;
    } else {
      return false;
    }
  };
  /* ************************************************************************************ */

  /* ******************************** For share contact ********************************* */
  const handleShare = async (tender: ProjectTenderDetailInterface) => {
    setProjectTenderDetailInterface(tender);
    setShowShareContactModal(true);

    const { setCurrentProjectTenderDetail } = await import(
      "../../../../../Controllers/Slices/tenderSlice"
    );
    dispatch(setCurrentProjectTenderDetail(tender));
  };

  const handleCloseShareModal = () => {
    setShowShareContactModal(false);
  };

  // //new actions edit options
  const handleCheckboxChangeNew = async (
    contactId: number,
    checked: boolean,
    fors: string
  ) => {
    const finalDataCollection: any = allfilterSharedList?.map((element) => {
      if (element.id === contactId) {
        return {
          id: element.id,
          by: element.by,
          folder_id: element.folder_id,
          first_name: element.first_name,
          last_name: element.last_name,
          profile_image: element.profile_image,
          mobile: element.mobile,
          landline: element.landline,
          email: element.email,
          address: element.address,
          city: element.city,
          post_code: element.post_code,
          role_name: element.role_name,
          isCheckedForShare:
            contactId === element.id ? true : element.isCheckedForShare,
          isCheckedForEdit:
            fors === "Edit" ? checked : element.isCheckedForEdit,
          isCheckedForView:
            fors === "View" ? checked : element.isCheckedForView,
        };
      } else {
        return element;
      }
    });

    setAllFilterContacts(mapShareContactDetailsList(finalDataCollection));
  };

  const handleCheckboxChangeForShare = async (
    contactId: number,
    checked: boolean
  ) => {
    const { setCheckSharedContact } = await import(
      "../../../../../Controllers/Slices/tenderSlice"
    );

    const data: ShareContactDetailsPayload = {
      id: contactId,
      isChecked: checked,
    };

    dispatch(setCheckSharedContact(data));
  };

  const handleCheckboxChangeForEdit = async (
    contactId: number,
    checked: boolean
  ) => {
    // handleCheckboxChangeNew(contactId,checked,"Edit");

    const { setCheckSharedContactEdit } = await import(
      "../../../../../Controllers/Slices/tenderSlice"
    );

    const data: ShareContactDetailsPayload = {
      id: contactId,
      isChecked: checked,
    };

    dispatch(setCheckSharedContactEdit(data));
    setUserType(userType);
  };

  const handleCheckboxChangeForView = async (
    contactId: number,
    checked: boolean
  ) => {
    handleCheckboxChangeNew(contactId, checked, "View");
    const { setCheckSharedContactView } = await import(
      "../../../../../Controllers/Slices/tenderSlice"
    );

    const data: ShareContactDetailsPayload = {
      id: contactId,
      isChecked: checked,
    };

    dispatch(setCheckSharedContactView(data));
    setUserType(userType);
  };

  const handleShareContact = async (e: React.FormEvent) => {
    e.preventDefault();

    const { getProjectTenderDetailList } = await import(
      "../../../../../Controllers/Thunks/tenderThunks"
    );

    if (projectTenderDetailInterface?.title === "Schedule of work") {
      const res = await shareContactForSowApi(
        projectTenderDetailInterface.project_tender_part_id,
        sharedContacttDetailList
      );

      if (res.status) {
        dispatch(getProjectTenderDetailList(folder_id));
        setShowShareContactModal(false);
        handleSelectUserType(null);

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Shared successfully",
            life: 3000,
          });
        }
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error creating document",
            life: 3000,
          });
        }
      }
    } else {
      const res = await shareContactForTenderListAndDocumentApi(
        projectTenderDetailInterface!.project_tender_part_id,
        sharedContacttDetailList
      );

      if (res.status) {
        dispatch(getProjectTenderDetailList(folder_id));
        setShowShareContactModal(false);


        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Shared successfully",
            life: 3000,
          });
        }
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error creating document",
            life: 3000,
          });
        }
      }
    }
  };

  const handleDeleteSOW = (
    projectTenderDetailInterface: ProjectTenderDetailInterface
  ): void => {
    confirmDialog({
      message: `Are you sure you want to delete this schedule of work?`,
      header: "Confirm the deletion",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: () => deleteSection(projectTenderDetailInterface),
      dismissableMask: true,
    });
  };

  const deleteSection = async (
    projectTenderDetailInterface: ProjectTenderDetailInterface
  ) => {
    try {
      const res = await deleteSow(
        projectTenderDetailInterface.project_tender_part_id
      );

      if (res.status) {
        const { getProjectTenderDetailList } = await import(
          "../../../../../Controllers/Thunks/tenderThunks"
        );

        dispatch(getProjectTenderDetailList(folder_id));
        ShowToast(
          toast,
          "success",
          "Success",
          "Schedule of work deleted successfully."
        );
      } else {
        ShowToast(toast, "error", "Failed", "Error deleting section.");
      }
    } catch (err) {
      ShowToast(toast, "error", "Failed", "Error deleting section.");
    }
  };

  /* Modal header */
  const shareContactModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">
        Share&nbsp;
        <span className="text-lowercase">
          {projectTenderDetailInterface?.title}
        </span>
      </h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseShareModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  /* Modal footer */
  const shareContactModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseShareModal}
      />
      <Button
        label={`${loading ? "Processing" : "Share"}`}
        loading={loading}
        onClick={handleShareContact}
        className="custom_btn primary"
      />
    </div>
  );
  /* ************************************************************************************ */

  /* ********************************* Tender overview ********************************** */
  const handleShowTenderOverview = (sowData: ProjectTenderDetailInterface) => {
    setShowTenderOverviewModal(true);
    setProjectTenderDetailInterface(sowData);
    if (sowData) {
      if (sowData?.have_cover_page_data === true) {
        setIsCoverPageAdded(true);
      } else {
        setIsCoverPageAdded(false);
      }
      if (sowData?.have_content_data === true) {
        setIsTenderContentAdded(true);
      } else {
        setIsTenderContentAdded(false);
      }
      if (sowData?.have_priliminiery_data === true) {
        setIsPreliminaryAdded(true);
      } else {
        setIsPreliminaryAdded(false);
      }
    } else {
      setIsCoverPageAdded(false);
      setIsTenderContentAdded(false);
      setIsPreliminaryAdded(false);
    }
  };

  const handleCloseTenderOverviewModal = () => {
    setShowTenderOverviewModal(false);
  };

  const handleContinueTenderSOW = () => {

    navigate(
      `/project/detail/default-service/pre-commencement/tender/sow/customize`,
      { state: projectTenderDetailInterface }
    );
  };

  /* Modal header */
  const tenderOverviewModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Tender overview</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseTenderOverviewModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  /* Modal footer */
  const tenderOverviewModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Cancel"
        className="custom_btn secondary"
        onClick={handleCloseTenderOverviewModal}
      />

      <Button
        label="Continue"
        onClick={handleContinueTenderSOW}
        className="custom_btn primary"
      />
    </div>
  );
  /* ************************************************************************************ */

  const handleSelectUserType = (
    type: "Employee" | "Professional" | "Client" | null
  ) => {
    setUserType(type);
  };

  /* ******************************** Common functions ********************************** */
  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  const goBack = () => {
    navigate(-1);
    goToTop();
  };
  /* *********************************************************************************** */
  return (
    <React.Fragment>
      <Toast ref={toast} />

      <div className="main_content layout_padding show_side_bar">
        {loadingProjectTenderDetail ? (
          <PageLoader />
        ) : error ? (
          <ErrorPage errorMessage={error} />
        ) : (
          <div className="page_content mt-0">
            <div className="page_breadcrumb_area">
              <ul className="page_breadcrumb">
                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                  {jobNo}: {address}
                </li>
                <li className="page_breadcrumb_item has_child">{folderName}</li>
                <li className="page_breadcrumb_item active">{featureName}</li>
              </ul>

              <button className="back_btn p-ripple" onClick={goBack}>
                <i className="bi bi-arrow-left me-2"></i>
                Back
                <Ripple />
              </button>
            </div>

            <div className="page_main_content_section">
              {projectTenderDetail?.length > 0 ? (
                <DataTable
                  value={projectTenderDetail.filter((det) => {
                    if (
                      (det.title.toLowerCase() === "schedule of work" &&
                        !isPermission_schedule_of_work) ||
                      (det.title.toLowerCase() === "schedule of work" &&
                        sharedBy !== null)
                      // && !isPermission_schedule_of_work && sharedBy===null
                    ) {
                      return false;
                    } else if (
                      det.title.toLowerCase() === "tender list" &&
                      !isPermission_tender_list
                    ) {
                      return false;
                    } else if (
                      (det.title.toLowerCase() === "tender document" &&
                        !isPermission_tender_document) ||
                      (det.title.toLowerCase() === "tender document" &&
                        sharedBy !== null)
                    ) {
                      return false;
                    } else {
                      return true;
                    }
                  })}
                  size="small"
                  tableStyle={{ minWidth: "50rem" }}
                  className="page_table p-0 p-sm-2"
                  rowHover
                >
                  <Column
                    header="Document"
                    headerClassName="text_purple"
                    body={(rowData) => (
                      <span className="text_bold text_purple">
                        {rowData.title ? rowData.title : "---"}
                      </span>
                    )}
                    style={{ width: "30%" }}
                  ></Column>

                  {(sharedBy === null) && (<Column
                    header="Shared"
                    headerClassName="text_purple"
                    body={sharedContactBody}
                    style={{ width: "30%" }}
                  ></Column>)}

                  <Column
                    body={tableActionBody}
                    className="table_btn_area"
                    style={{ width: "40%" }}
                  ></Column>
                </DataTable>
              ) : (
                <NoDataCreated message={`No tender documents found!`} />
              )}
            </div>
          </div>
        )}
      </div>

      {/* Tender document modal */}
      <TenderDocumentModal
        isOpen={showDocumentModal}
        onClose={handleCloseDocumentModal}
        dataState="Add"
        serviceName={featureName}
        toast={toast}
        documentName={documentName}
        setDocumentName={setDocumentName}
        uploadedFileName={fileName}
        handleFileUpload={handleFileUpload}
        handleClearFile={handleClearFile}
        loading={loading}
        documentNameError={documentNameError}
        fileError={fileError}
        isDocumentNameRequired={true}
        isFileRequired={true}
        handleCreateDocument={handleCreateTenderDocument}
      />

      {/* Share contact modal */}
      <Dialog
        visible={showShareContactModal}
        header={shareContactModalHeader}
        footer={shareContactModalFooter}
        headerClassName="custom_modal_header"
        className="custom_modal_dialog modal_dialog_md"
        onHide={() => {
          if (!showShareContactModal) return;
          setShowShareContactModal(false);
        }}
        contentClassName="pt-0"
        dismissableMask
      >
        <div className="custom_modal_body fixed_height">
          <div className="pt-0 ps-2 pe-2 pb-2 w-100">
            <div className="share_contact_tab_header">
              <div className="contact_tabs">
                <div className="contact_tabs">
                  <div className="contact_tab_item">
                    <button
                      type="button"
                      className={`contact_tab_btn ${userType === null ? "active" : ""
                        } p-ripple`}
                      onClick={() => handleSelectUserType(null)}
                    >
                      All
                      <Ripple
                        pt={{
                          root: {
                            style: { background: "rgba(164, 96, 253, 0.2)" },
                          },
                        }}
                      />
                    </button>
                  </div>
                  <div className="contact_tab_item">
                    <button
                      type="button"
                      className={`contact_tab_btn ${userType === "Employee" ? "active" : ""
                        } p-ripple`}
                      onClick={() => handleSelectUserType("Employee")}
                    >
                      Employee
                      <Ripple
                        pt={{
                          root: {
                            style: { background: "rgba(164, 96, 253, 0.2)" },
                          },
                        }}
                      />
                    </button>
                  </div>
                  <div className="contact_tab_item">
                    <button
                      type="button"
                      className={`contact_tab_btn ${userType === "Professional" ? "active" : ""
                        } p-ripple`}
                      onClick={() => handleSelectUserType("Professional")}
                    >
                      Professional
                      <Ripple
                        pt={{
                          root: {
                            style: { background: "rgba(164, 96, 253, 0.2)" },
                          },
                        }}
                      />
                    </button>
                  </div>
                  <div className="contact_tab_item">
                    <button
                      type="button"
                      className={`contact_tab_btn ${userType === "Client" ? "active" : ""
                        } p-ripple`}
                      onClick={() => handleSelectUserType("Client")}
                    >
                      Client
                      <Ripple
                        pt={{
                          root: {
                            style: { background: "rgba(164, 96, 253, 0.2)" },
                          },
                        }}
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              {filteredContacttDetailList?.length > 0 ? (
                <div className="col-12 custom_padding_x">
                  <div className="access_head">
                    <div className="access">
                      <h6>Edit</h6>
                    </div>
                    <div className="access">
                      <h6>View</h6>
                    </div>
                  </div>
                  <ul className="assign_contact_list_area">
                    {filteredContacttDetailList.map((contact) => {
                      const contactId = contact.id;
                      return (
                        <li
                          key={contactId}
                          className="assign_contact_list share_contact_list w-100"
                        >
                          {/* <Checkbox
                            onChange={(e) =>
                              handleCheckboxChangeForShare(
                                contactId,
                                e.checked || false
                              )
                            }
                            checked={contact.isCheckedForShare!}
                          /> */}

                          <button
                            className={`contact_slide_tab assign_contact p-ripple ${contact.isCheckedForShare! ? "" : ""
                              }`}

                          >
                            {contact?.profile_image ? (
                              <Image
                                className="contact_profile_img"
                                src={`${baseURL}/${contact?.profile_image}`}
                                alt={
                                  contact?.first_name + " " + contact?.last_name
                                }
                              />
                            ) : (
                              <div className="contact_no_profile">
                                {contact?.first_name[0] + contact?.last_name[0]}
                              </div>
                            )}
                            <div className="contact_slide_det">
                              <h6>
                                {contact?.first_name + " " + contact?.last_name}
                              </h6>
                              <p>
                                {contact?.role_name
                                  ? contact?.role_name
                                  : "---"}
                              </p>
                            </div>
                            <Ripple
                              pt={{
                                root: {
                                  style: {
                                    background: "rgba(139, 96, 253, 0.2)",
                                  },
                                },
                              }}
                            />
                          </button>

                          <div className="access_check_area">
                            <Checkbox
                              onChange={(e) =>
                                handleCheckboxChangeForEdit(
                                  contactId,
                                  e.checked || false
                                )
                              }
                              checked={contact.isCheckedForEdit!}
                            />
                          </div>

                          <div className="access_check_area">
                            <Checkbox

                              onChange={(e) =>
                                handleCheckboxChangeForView(
                                  contactId,
                                  e.checked || false
                                )
                              }
                              checked={contact.isCheckedForView!}
                            />
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : (
                <div className="col-12 pt-4">
                  <div className="no_data_found ">
                    <h6>No contacts found!</h6>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Dialog>

      {/* Share list modal */}
      <Dialog
        visible={showSharedListModal}
        header={shareListModalHeader}
        headerClassName="custom_modal_header"
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseSharedListModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <div className="p-1 pt-2 pt-sm-2 pb-sm-2 w-100">
            <div className="row">
              <div className="col-12">
                {selectedTenderSharedContacts.map((contact) => (
                  <article key={contact.id} className="shared_contact_body">
                    <h6>
                      {contact.first_name} {contact.last_name}
                    </h6>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      {/* Tender overview modal */}
      <Dialog
        visible={showTenderOverviewModal}
        header={tenderOverviewModalHeader}
        footer={tenderOverviewModalFooter}
        headerClassName="custom_modal_header"
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseTenderOverviewModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
            <div className="table-responsive">
              <table className="table table-bordered mb-0 custom_table">
                <thead>
                  <tr>
                    <th scope="col" className="title_head">
                      Title
                    </th>
                    <th scope="col" className="text-center status_head">
                      Added status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Cover page</td>
                    <td className="text-center">
                      {isCoverPageAdded ? (
                        <span className="text-success">Yes</span>
                      ) : (
                        <span className="text-warning">No</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Tender content</td>
                    <td className="text-center">
                      {isTenderContentAdded ? (
                        <span className="text-success">Yes</span>
                      ) : (
                        <span className="text-warning">No</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Preliminary</td>
                    <td className="text-center">
                      {isPreliminaryAdded ? (
                        <span className="text-success">Yes</span>
                      ) : (
                        <span className="text-warning">No</span>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Dialog>

      {/* Show success message */}
      <div
        className={`message_backdrop ${showAlert ? "show" : ""}`}
        onClick={handleCloseAlert}
      >
        <div
          className={`message_box ${showAlert ? "show" : ""}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="message_box_content">
            <i className="bi bi-check-circle-fill message_box_icon"></i>
            <h6 className="message_box_message">{successMessage}</h6>
          </div>
        </div>
      </div>
      {/*  */}
    </React.Fragment>
  );
};

export default Tender;
